import CouponCard from '@/components/cards/coupon-card'
import NotData from '@/components/elements/not-data'
import SpinnerLoading from '@/components/elements/spinner'
import Toast from '@/components/elements/toast'
import ButtonMore from '@/components/layout/action/button-more'
import Layout from '@/components/layout/layout'
import ModalActionsDashboard from '@/components/modal/modal-actions-dashboard'
import { fetchCoupons } from '@/services/api/coupons/coupons'
import { setCouponsFn } from '@/store/features/coupons'
import { sessionRefrestUpdate } from '@/store/features/state'
import { AppDispatch, RootState } from '@/store/store'
import CouponsEntity from '@/entities/api/coupons/coupons'
import JwtPayload from '@/entities/api/jwt'
import { Box, Flex, Grid, Heading, Separator } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const Coupons = ({ data }: { data: JwtPayload }) => {
	const [modalAddOpen, setmodalAddOpen] = useState<Boolean>(false)
	const [modalEditOpen, setmodalEditOpen] = useState<Boolean>(false)
	const [isLoading, setIsloading] = useState<boolean>(false)
	const [coupon, setCoupon] = useState<CouponsEntity | {}>()
	const token = useSelector((state: RootState) => state.auth.token)
	const couponRefrest = useSelector(
		(state: RootState) => state.state.couponRefrest
	)
	const coupons = useSelector((state: RootState) => state.coupons.coupons)
	const dispatch = useDispatch<AppDispatch>()

	useEffect(() => {
		const getCoupons = async () => {
			try {
				setIsloading(true)
				if (coupons.length === 0) {
					const response = await fetchCoupons(token ?? '')
					if (response?.status === 401) {
						dispatch(sessionRefrestUpdate())
						return
					}
					dispatch(setCouponsFn(response?.data ?? []))
				}
				setIsloading(false)
			} catch (error) {
				Toast({ type: 'error', message: 'No se pudo obtener los cupones' })
				setIsloading(false)
			}
		}

		getCoupons()
	}, [couponRefrest])

	const openEditModal = async (coupon: CouponsEntity) => {
		setCoupon(coupon)
		setmodalEditOpen(true)
	}

	return (
		<Layout data={data}>
			{isLoading ? (
				<SpinnerLoading color='black' size='xl' />
			) : (
				<>
					<Flex
						w='full'
						p='4'
						alignItems='center'
						flexDirection={{ base: 'column', lg: 'row' }}
						justifyContent={{ base: 'start', lg: 'space-between' }}
					>
						<Heading
							as='h2'
							color='black'
							fontSize={{ base: '2xl', sm: '3xl' }}
							textAlign={{ base: 'center', sm: 'start' }}
							whiteSpace='normal'
							wordBreak='break-word'
							fontWeight='800'
						>
							Cupones
						</Heading>

						<Box
							w={{ base: 'full', xl: 'auto' }}
							flexDirection={{ base: 'column', sm: 'row' }}
							display='flex'
							alignItems='center'
							justifyContent={{ base: 'start', sm: 'center' }}
							p='4'
						>
							<ButtonMore click={() => setmodalAddOpen(true)} />
						</Box>
					</Flex>
					<Separator w='full' />
					<Box w='full' p='6'>
						{coupons && coupons.length > 0 ? (
							<Grid
								w='full'
								templateColumns={{
									base: '1fr',
									sm: 'repeat(2, 1fr)',
									lg: 'repeat(4, 1fr)',
									xl: 'repeat(6, 1fr)',
								}}
								gap='4'
							>
								{coupons.map((coupon, index) => (
									<CouponCard
										key={index}
										token={token ?? ''}
										coupon={coupon}
										click={() => openEditModal(coupon)}
									/>
								))}
							</Grid>
						) : (
							<NotData />
						)}
					</Box>
					{modalAddOpen && (
						<ModalActionsDashboard
							open={modalAddOpen}
							action='add-coupon'
							close={() => setmodalAddOpen(false)}
						/>
					)}
					{modalEditOpen && (
						<ModalActionsDashboard
							open={modalEditOpen}
							action='edit-coupon'
							data={coupon}
							close={() => setmodalEditOpen(false)}
						/>
					)}
				</>
			)}
		</Layout>
	)
}

export default Coupons
